module.exports = __webpack_public_path__ + "site/img/12.03ba983e.jpg";